import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { PackagesResponse } from 'src/app/models/interface/tv/packagesResponse';

@Injectable({
  providedIn: 'root'
})
export class MasMediaTvService {

  appData;

  constructor(
    private httpClient: HttpClient,
    private appService: AppService,
  ) {
      this.appData = this.appService.settings;
  }

  getActiveTvPackages(email: string, profile: string): Observable<any> {
    const params = new HttpParams().append('email', email).append('profile', profile);
    return this.httpClient.get<PackagesResponse>(`${this.appData.webApi}/mas-media-tv/consultService`, { params });
  }
}
